import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Spinner } from "react-bootstrap";
import MonthlyCalendar from "./MontlyCalender";
import { useSelector } from "react-redux";

const Compliance = ({ employees }) => {
  const userState = useSelector((state) => state.loginData.userData);
  // console.log("first", employees)

  // const employees = [
  //     { id: "E123", name: "John Doe" },
  //     { id: "E124", name: "Jane Smith" },
  //   ];

  const [loader, setLoader] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1); // 1-12
  const [employeeId, setEmployeeId] = useState(null); // For team lead

  useEffect(() => {
    getCompliance();
  }, [month, year, employeeId]);

  const getCompliance = async () => {
    setLoader(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + "/task/get/alltask/compailance",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userState?.token}`,
          },
          body: JSON.stringify({
            empId: employeeId || userState.empId,
            month: month,
            year: year,
          }),
        }
      );

      const res = await response.json();
      if (res.status === 200) {
        console.log("resresres", res.data);
        setTasks(res.data);
      }
    } catch (Err) {
      console.log("Error while compliance =>", Err);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Container className="outletPadding">
      {/* <h3>Compliance Report</h3> */}
      {userState.resourceType !== "employee" && (
        <Row className="mb-3 justify-content-end">
          <Col xs={8} md={3}>
            <Form.Label>Select employee</Form.Label>
            <Form.Select
              value={employeeId || ""}
              onChange={(e) => {
                setTasks([]); setEmployeeId(e.target.value);
              }}
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.value} value={emp.value}>
                  {emp.label}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      )}

      {/* Filters for Month and Year */}
      <Row className="mt-5 mb-3 justify-content-center">
        <Col xs={6} md={2}>
          <Form.Select value={month} onChange={(e) => setMonth(e.target.value)}>
            {Array.from({ length: 12 }, (_, i) => (
              <option key={i + 1} value={i + 1}>
                {new Date(0, i).toLocaleString("default", { month: "long" })}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={6} md={2}>
          <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
            {[...Array(2)].map((_, i) => (
              <option key={i} value={new Date().getFullYear() - i}>
                {new Date().getFullYear() - i}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>

      {/* Calendar */}
      {loader ? (
        <div className="text-center my-4">
          <Spinner size="lg" />
        </div>
      ) : (
        <MonthlyCalendar year={year} month={month} tasks={tasks} />
      )}
    </Container>
  );
};

export default Compliance;
